import axios from 'utils/axios';
import { DoctorsFilterType } from 'types';

export const getDoctors = (filter: DoctorsFilterType) => {
  return axios.get('/publicapi/v1/doctors', {
    params: filter
  });
};
